import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Product } from '../../../shared/models/product.model';

@Injectable({ providedIn: 'root' })
export class ViewedProductsService {
  viewedProducts: Array<Product> = [];
  currentProducts$: BehaviorSubject<Array<Product>> = new BehaviorSubject([]);
  productsSort$: BehaviorSubject<string> = new BehaviorSubject('default');
  product: Product;

  constructor() {}

  changePage(arr: Array<Product>) {
    this.viewedProducts = arr;
    this.currentProducts$.next(arr);
  }

  setQuantity(): Observable<Array<number>> {
    return this.currentProducts$.asObservable().pipe(
      map(results => {
        if (results && results.length) {
          const productIds: Array<number> = [];
          results.forEach(result => {
            productIds.push(result.id);
          });
          return productIds;
        } else if (results && !results.length) {
          return [];
        }
      })
    );
  }

  findAndSetCurrentProduct(productId: number, quantity: number): Product {
    const searchedProduct = this.viewedProducts.find(
      product => product.id === productId
    );
    this.product = Object.assign(new Product(), searchedProduct);
    this.setProductQuantity(quantity);
    return this.product;
  }

  findProductCategory(productId: number) {
    const product = this.viewedProducts.find(
      product => product.id === productId
    );
    if (product) {
      return product.categories[0].name;
    } else {
      return '';
    }
  }

  setProductQuantity(quantity: number): void {
    this.product.quantity = quantity;
  }

  setProductsSort(value: string) {
    this.productsSort$.next(value);
  }
  getProductsSort() {
    return this.productsSort$.value;
  }
}
